import { render, staticRenderFns } from "./VxButtonCopy.vue?vue&type=template&id=40531e55&"
import script from "./VxButtonCopy.vue?vue&type=script&lang=js&"
export * from "./VxButtonCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports